<template>
  <div id="winners" class="winners-list px-0">
    <div class="col-12 col-lg-11 px-0 mx-auto winners-container"  v-if="loaded&&winnersChunks">
      <div class="winners-back double-border">
        <b-carousel :interval="3000" class="winners-carousel">
          <b-carousel-slide v-for="(chunk, index) in winnersChunks" :key="index">
            <div v-for="(winner, index) in chunk" :key="index"
                 class="carousel-winner-itm col row mx-0 justify-content-start justify-content-lg-between px-0 px-lg-1">
              <div class="col-4 col-lg-5 winner-img px-0 text-center d-flex">
                <a class="cursor-pointer d-flex"

                   v-lazy-container="{ selector: 'img', loading: require('@/../public/images/icons/main-loader.svg') }">
                  <img :src="winner.preview" alt="VipMagnit онлайн Казино"
                       :data-src="winner.preview"
                       class="winner-game-img d-flex my-auto">
                </a>
              </div>
              <div class="col-8 col-lg-7 winner-info px-0 pl-1 pl-lg-2">
                <span class="w-100 d-block winner-login">{{ winner.login }}</span>
                <span class="win-amount">
                  {{ winner.win}}<i class="fa fa-ruble-sign"></i>
                </span>
<!--                <span class="winner-game-name" :title="winner.game_name">{{winner.game_name}}</span>-->
              </div>
            </div>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
    <div v-else class="row justify-content-center w-100 color-red mx-0 h-100">
      <i class="fa fa-spinner fa-spin fa-fw my-auto"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Winners',
  data () {
    return {
      loaded: false,
      winnersChunks: null
    }
  },
  computed: {
    winners () {
      return this.$store.getters.getWinnersList
    },
    isMobile () {
      return this.$_config.environment.mobile
    },
  },
  methods: {
    gotoGameView (data) {
      if (!this.$store.getters.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для запуска игры нужно авторизоваться')
      }
      const gameName = data.game_name.split(' ').join('-')

      if (this.isMobile) {
        return this.$router.push({
          name: 'LaunchGameMobile',
          params: {
            gameName: gameName,
            gameId: data.game_id,
            game: {
              name: gameName,
              gameId: data.game_id,
              provider: data.provider,
              picture: data.picture
            },
            provider: data.provider,
            isLive: 0,
            restoring: false
          }
        })
      }

      this.$router.push({
        name: 'LaunchGame',
        params: {
          gameName: gameName,
          gameId: data.game_id,
          game: {
            name: gameName,
            gameId: data.game_id,
            provider: data.provider,
            picture: data.picture
          },
          provider: data.provider,
          isLive: 0,
          restoring: false
        }
      })
    },
    winnersToChunks (winners) {
      if (this.$route.name !== 'home') {
        return
      }
      const tempArray = []
      let index = 0
      let chunkSize = 9
      const allowWidth = parseInt(document.getElementById('winners').offsetWidth)
      switch (true) {
        case allowWidth >= 1200 :
          chunkSize = 9
          break
        case allowWidth >= 900 && allowWidth < 1200:
          chunkSize = 5
          break
        case allowWidth >= 760 && allowWidth < 900:
          chunkSize = 5
          break
        case allowWidth >= 570 && allowWidth < 760:
          chunkSize = 4
          break
        case allowWidth >= 375 && allowWidth < 570:
          chunkSize = 3
          break
        case allowWidth < 375:
          chunkSize = 2
          break
      }
      for (index = 0; index < winners.length; index += chunkSize) {
        const myChunk = winners.slice(index, index + chunkSize)
        tempArray.push(myChunk)
      }
      this.winnersChunks = tempArray
    }
  },
  mounted () {
    const winners = this.$store.getters.getWinnersList
    if (winners) {
      this.loaded = true
      if (!this.winnersChunks) {
        this.winnersToChunks(winners)
      }
      const _this = this
      window.addEventListener('resize', function () {
        _this.winnersToChunks(winners)
      })
    }
  },
  watch: {
    winners (newVal) {
      if (newVal) {
        if (!this.winnersChunks) {
          this.winnersToChunks(newVal)
        }
        const _this = this
        window.addEventListener('resize', function () {
          _this.winnersToChunks(newVal)
        })
        this.loaded = true
      }
    }
  }
}
</script>

<style>
  .winners-list{
    width: 100%;
    height: 120px;
    overflow: visible;
    background-color: #080d13;
  }
  .winners-list .carousel-item {
    height: 100px;
  }
  .winner-login{
    color: #ffffff;
    user-select: none;
  }
  .win-amount{
    color:#000000;
    font-weight: 600;
  }
  .winner-game-name{
    display: block;
    max-width: 100%;
    max-height: 20px;
    overflow: hidden;
    overflow-wrap: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: none;
  }
  .winner-game-img{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    max-width: 100%;
    object-fit: cover;
  }
  .winners-back{
    position: absolute;
    width: 100%;
    outline: none !important;
    top: -50px;
    border-radius:5px;
    background-image: linear-gradient(45deg, rgba(230,0,29,1) 0%, rgba(247,81,55,1) 100%);
    z-index: 2;
  }

  .winners-carousel .carousel-control-prev{
    opacity: 0.7 !important;
    z-index: 2;
    left: 0;
    text-align: left;
    justify-content: flex-start;
    width: 4%;
    padding: 0 15px;
    background-color: transparent;
  }
  .winners-carousel .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23980019' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e")
  }
  .winners-carousel .carousel-control-next-icon{
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23980019' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
  }

  .winners-carousel .carousel-control-next{
    opacity: 0.7 !important;
    z-index: 2;
    text-align: right !important;
    justify-content: flex-end;
    width: 4%;
    padding: 0 15px;
    background-color: transparent;
  }

  .winner-list .carousel-caption {
    width: 82%;
    left: 9%;
    overflow-x: hidden;
    white-space: nowrap;
  }
  .winners-carousel .carousel-inner{
    padding: 0 15px !important;
  }
  .win-amount i {
    font-size: 13px;
    margin-left: 2px;
  }
  .winner-list .carousel-item {
    height: 100px;
  }
  .winner-list .carousel-caption span{
    font-size: 15px;
  }
  .winners-carousel .carousel-caption{
    left: 0 !important;
    width: 100%;
    -webkit-box-pack: justify !important;
    justify-content: space-between !important;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    bottom: 15px !important;
    padding-bottom: 0 !important;
    padding-top : 0 !important;
    text-align:left !important;
  }
  .fa-spinner{
    font-size: 35px;
  }
  @media (min-width: 1450px) and (max-width: 1600px) {
    .winners-carousel .carousel-caption {
      bottom: 0 !important;
    }
  }
  @media (min-width: 1350px) and (max-width: 1450px) {
    .winners-carousel .carousel-caption {
      bottom: 20px !important;
    }
    .winner-game-img {
      width: 55px;
      height: 55px;
    }
  }
  @media (min-width: 320px) and (max-width: 1366px) {
    .winner-list .carousel-caption {
      white-space: normal;
    }

    .winner-list .carousel-caption span{
      font-size: 12px;
    }
  }
  @media (max-width: 992px) {
    .winners-list{
      height:auto ;
    }
    .winners-back {
      position: relative;
      top: 0;
      border-radius: 0;
    }
    .winners-list-area .carousel-item {
      height: 55px !important;
    }
    .winners-carousel .carousel-inner {
      padding: 0 10px !important;
    }
    .winner-game-img {
      width: 40px;
      height: 40px;
    }
    .winners-carousel .carousel-caption {
      bottom: 5px !important;
      padding-bottom: 0 !important;
      padding-top: 0 !important;
      text-align: left !important;
    }
    .winner-info span{
      font-size: 12px;
      color: #000000;
      user-select: none;
    }
    .winners-list .carousel-item {
      height: 70px;
    }
    .winners-list-area {
      height: 55px !important;
    }
    .win-amount i {
      font-size: 10px;
    }
    .winners-carousel .carousel-winner-itm:first-child,
    .winners-carousel .carousel-winner-itm:last-child{
      opacity: 1;
    }
    .winners-carousel .carousel-control-prev{
      width: 20%;
    }
  }
</style>

<style scoped>

</style>
